import { useQuery } from '@tanstack/react-query'
import { searchSolutions } from '@/lib/api/kb'
import { normalizeQuery } from '@/lib/compute/universe'

/** Solutions full-text search in kb; waits for at least two characters. */
export function useSolutionsSearch(q: string) {
  const query = normalizeQuery(q)
  return useQuery({
    queryKey: ['kb', 'solutions', 'search', query],
    queryFn: () => searchSolutions(query),
    enabled: query.length >= 2,
    // The copy refreshes hourly; 30s avoids refetching while the user types back and forth.
    staleTime: 30_000,
  })
}
